module.exports = __webpack_public_path__ + "img/Black_Shawl.c172246d.png";